import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';
// Single source of truth for the brand colour lives in the SCSS token file; its
// `:export` block makes the values readable from TS.
import variables from './_variables.module.scss';

export const AppPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: variables.primary,
          inverseColor: variables.primary,
          hoverColor: variables.primary,
          activeColor: variables.primary
        },
        highlight: {
          background: variables.primaryHighlight,
          focusBackground: variables.primaryHighlightFocus,
          color: '{primary.color}',
          focusColor: '#ffffff'
        },
        formField: {
          hoverBorderColor: '{primary.color}'
        }
      }
    }
  }
});
